import { useEffect, useState, useRef } from 'react';

const useDynamicHeight = () => {
  const [dynamicHeight, setDynamicHeight] = useState('100vh');
  const [navHeight, setNavHeight] = useState(70);
  const prevDevicePixelRatio = useRef(window.devicePixelRatio);

  const calculateHeight = () => {
    const navbar = document.querySelector('.navbar-expand-lg');
    const subMsgBar = document.querySelector('.subscribe-msg');
    let navbarHeight = navbar ? navbar.offsetHeight : 0;
    if (subMsgBar) {
      navbarHeight += subMsgBar.offsetHeight;
    }
    setNavHeight(navbarHeight);
    setDynamicHeight(`calc(100vh - ${navbarHeight}px)`);
  };

  useEffect(() => {
    const handleResizeOrZoom = () => {
      if (window.devicePixelRatio !== prevDevicePixelRatio.current) {
        prevDevicePixelRatio.current = window.devicePixelRatio;
        calculateHeight(); // zoom changed
      } else {
        calculateHeight(); // normal resize
      }
    };

    // ResizeObserver for better zoom handling
    const navbar = document.querySelector('.navbar-expand-lg');
    const resizeObserver = navbar ? new ResizeObserver(() => calculateHeight()) : null;

    calculateHeight();
    window.addEventListener('resize', handleResizeOrZoom);
    resizeObserver?.observe(navbar);

    return () => {
      window.removeEventListener('resize', handleResizeOrZoom);
      resizeObserver?.disconnect();
    };
  }, []);

  return { dynamicHeight, navHeight };
};

export default useDynamicHeight;
